import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import { url, sitename } from '../../../config';

class ConfirmEmail extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      token: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    })
  };

  render() {
    const buttonStyle = {
      margin: 0,
      fontFamily: 'Arial',
      padding: '10px 16px',
      textDecoration: 'none',
      borderRadius: '2px',
      border: '1px solid',
      textAlign: 'center',
      verticalAlign: 'middle',
      fontWeight: 'normal',
      fontSize: '18px',
      whiteSpace: 'nowrap',
      background: '#ffffff',
      borderColor: '#0667B3',
      backgroundColor: '#0667B3',
      color: '#ffffff',
      borderTopWidth: '1px',
    };

    const textStyle = {
      color: '#404040',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Arial',
      fontSize: '16px',
      padding: '35px'
    };
    const { content: { token, email, logo } } = this.props;
    let verificationURL = url + `/user/verification?confirm=${token}&email=${email}`;

    return (
      <Layout>
        <Header color="#0667B3" backgroundColor="#F7F7F7" logo={logo} />
        <Body textStyle={textStyle}>
          <div>
            Hallo,
          </div>
          <EmptySpace height={20} />
          <div>
            Willkommen bei Expozed1! Um richtig loszulegen, müssen Sie zunächst Ihre E-Mail Adresse bestätigen. Klicken Sie bitte auf folgenden Link:
          </div>
          <EmptySpace height={40} />
          <div>
            <a style={buttonStyle} href={verificationURL}>Jetzt E-Mail Adresse bestätigen.</a>
          </div>
          <EmptySpace height={30} />
          <div>
            Vielen Dank, <br />
            Ihr Expozed1 Team
          </div>
        </Body>
        <Footer />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default ConfirmEmail;
